<template>
  <div class="banner_container" v-show="swiperData && swiperData.length > 0">
    <swiper
      :modules="modules"
      :slidesPerView="type === 'card_slide' ? 1.2 : 1"
      :centeredSlides="true"
      loop
      :autoplay="{
        disableOnInteraction: false
      }"
      :spaceBetween="type === 'card_slide' ? 15 : 0"
      class="banner_wrapper"
      :class="{ banner_wrapper_full: type === 'tile', banner_wrapper1: type === 'card_slide' }"
      :pagination="pagination"
      @swiper="setSwiper"
    >
      <swiper-slide v-for="(item, index) in swiperData" :key="index" @click="skipHandle(item)">
        <img :src="item.dataImgUrl" class="banner_img" />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script lang="ts" setup>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Swiper as SwiperType, Autoplay, Pagination } from 'swiper'
import { LmsDecorateModule } from '@/api/Models/HomeConfig'
import { computed, onActivated, ref, onDeactivated } from 'vue'
import { useThemeColor } from '@/utils/theme'
import { useRouter } from 'vue-router'
import { handleExternalUrl } from '@/utils/navigation'

const props = defineProps<{
  data: LmsDecorateModule
}>()

const swiperInstance = ref()
const setSwiper = (swiper: SwiperType) => {
  swiperInstance.value = swiper
}
onDeactivated(() => {
  swiperInstance.value.autoplay.pause()
})
onActivated(() => {
  swiperInstance.value.autoplay.start()
})

const router = useRouter()
interface TSwiperItem {
  dataJumpType: number
  dataJumpUrl: string
  dataJumpId: string
  dataJumpName: string
}
const skipHandle = (item: TSwiperItem) => {
  switch (item.dataJumpType) {
    case 1: // 课程
      router.push({
        name: 'courseDetail',
        query: {
          id: item.dataJumpId,
          courseId: '',
          endingType: 0,
          channel: 1,
          courseType: 'course'
        }
      })
      break
    case 2: // 课件
      router.push({
        name: 'courseDetail',
        query: {
          id: item.dataJumpId,
          courseId: '',
          endingType: 0,
          channel: 1,
          courseType: 'courseWare'
        }
      })
      break
    case 3: // 链接
      // router.push('/webview?url=' + encodeURIComponent(item.dataJumpUrl))
      handleExternalUrl({ jumpUrl: item.dataJumpUrl })
      break
    case 4: // 资讯
      router.push('/broadcastDetail/' + item.dataJumpId)
      break
    case 5: // 培训
      router.push('/trainingDetail?id=' + item.dataJumpId)
      break
    case 6: // 考试
      router.push('/examInfo?examId=' + item.dataJumpId)
      break
    case 7: // 调查
      router.push('/surveyInfo?investigationId=' + item.dataJumpId)
      break
    case 8: // 直通车
      router.push('/ceo')
      break
    default:
      break
  }
}

const modules = [Autoplay, Pagination]
const swiperData = computed(() => {
  try {
    // console.log(JSON.parse(props.data.lmsDecorateModuleCategories[0].datas[0].json))
    return JSON.parse(props.data.lmsDecorateModuleCategories[0].datas[0].json)
  } catch (error) {
    return []
  }
})
const type = computed(() => {
  try {
    return JSON.parse(props.data.extendInfo).type
  } catch (error) {
    return {}
  }
})

const themeColor = useThemeColor()
const pagination = {
  clickable: true,
  renderBullet(index: number, className: string) {
    return '<span class="' + className + '"></span>'
  }
}
</script>

<style lang="less" scoped>
.banner_container {
  .banner_wrapper {
    margin: 12px 16px;
    width: calc(100vw - 32px);
    height: calc((100vw - 32px) * 0.408);
  }

  .banner_wrapper1 {
    margin: 12px 0;
    width: 100vw;
    height: calc(100vw * 0.408);
  }

  .banner_img {
    width: 100%;
    height: 100%;
    // object-fit: cover;
    border-radius: 8px;
  }

  .banner_wrapper_full {
    margin: 0 0 12px;
    width: 100vw;
    height: calc((100vw) * 0.408);

    .banner_img {
      border-radius: 0;
    }
  }
}

:deep(.swiper-pagination) {
  position: absolute;
  bottom: 12px;
  left: 12px;
  z-index: 10;
  display: flex;
  align-items: center;
}

:deep(.swiper-pagination-bullet) {
  width: 8px;
  height: 2px;
  background: #ffffff;
  border-radius: 1px;
  margin-right: 4px;
}

:deep(.swiper-pagination-bullet-active) {
  height: 3px;
  background: v-bind(themeColor);
}
</style>
